import React, { Component } from "react";
import Social_BenefitsForm from "../Social_benefitsForm/Social_BenefitsForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Social_BenefitsPage
Description : Componente que contienen el formulario de la pantalla Social_Benefits 
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina – Se llama al componente Social_BenefitsForm
================================================================================ */
class Social_benefitsPage extends Component{
    render(){
        return(
            <div>                    
                <Social_BenefitsForm/>
            </div>
        )   
    }
}

export default Social_benefitsPage;